import { render, staticRenderFns } from "./RoomPlaceGridItem.vue?vue&type=template&id=42a29d5d&"
import script from "./RoomPlaceGridItem.vue?vue&type=script&lang=js&"
export * from "./RoomPlaceGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports